// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1DQpo","visuallyhidden":"_1h-DG","hide-text":"bcoWD","center":"_1mRdU","noprint":"_1u2WZ","headline":"_9uXep _1o64I"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-headline/styles/sports.scss
 ** module id = 1005
 ** module chunks = 2
 **/